import type { CategoryHeaderModelProps } from '@/components/catalog/category-header/category-header.model'
import { useCategoryHeaderModel } from '@/components/catalog/category-header/category-header.model'
import { CategoryHeaderView } from '@/components/catalog/category-header/category-header.view'

export function CategoryHeaderViewModel(props: CategoryHeaderModelProps) {
  const model = useCategoryHeaderModel(props)
  return <CategoryHeaderView {...model} />
}
